import { render, staticRenderFns } from "./LeadLovers.vue?vue&type=template&id=02a3835c&scoped=true&"
import script from "./LeadLovers.vue?vue&type=script&lang=js&"
export * from "./LeadLovers.vue?vue&type=script&lang=js&"
import style0 from "./LeadLovers.vue?vue&type=style&index=0&id=02a3835c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a3835c",
  null
  
)

export default component.exports